import type { InspectJobChangeKind, UrlStatusChangeKind } from '../api/types';

export function inspectJobChangeLabel(kind: InspectJobChangeKind | UrlStatusChangeKind): string {
  switch (kind) {
    case 'became_indexed':
      return 'ایندکس شد';
    case 'became_not_indexed':
      return 'ایندکس از دست رفت';
    case 'became_error':
      return 'خطا شد';
    case 'resolved_error':
      // error → excluded: API inspect recovered, page still not indexed
      return 'وضعیت مشخص شد';
    case 'only_in_new':
      return 'فقط در جاب جدید';
    case 'only_in_old':
      return 'فقط در جاب قبلی';
    case 'other':
      return 'تغییر دیگر';
    case 'unchanged':
      return 'بدون تغییر';
    default:
      return kind;
  }
}

export function inspectJobChangeVariant(
  kind: InspectJobChangeKind | UrlStatusChangeKind,
): 'success' | 'warning' | 'danger' | 'secondary' | 'info' {
  switch (kind) {
    case 'became_indexed':
      return 'success';
    case 'became_not_indexed':
    case 'resolved_error':
      return 'warning';
    case 'became_error':
      return 'danger';
    case 'only_in_new':
    case 'only_in_old':
      return 'info';
    case 'unchanged':
      return 'secondary';
    default:
      return 'secondary';
  }
}

export function bucketStatusLabel(
  bucket: 'indexed' | 'excluded' | 'error' | null,
): string {
  if (!bucket) return '—';
  if (bucket === 'indexed') return 'ایندکس‌شده';
  if (bucket === 'error') return 'خطا';
  return 'ایندکس‌نیست';
}
